import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'

import './styles/Style.css'

document.addEventListener('touchmove', function (event: any) {
    if (event.scale !== 1) { event.preventDefault(); }
  }, false);

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
)